import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '432px',
      height: '264px',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      background: '#FFFFFF',
      boxShadow: '0px 4px 4px #00000040',
      outline: `2px dashed #B1B1B1`,
      borderRadius: '4px',
      position: 'absolute',
      zIndex: 10,
    },

    iconContainer: {
      margin: '0 auto',
      paddingTop: '16px',
      order: 0,
    },

    textContainer: {
      textAlign: 'center',
      margin: '16px',
      order: 1,
    },
  },
  {
    name: 'FileInProgressModal',
  },
);
